import { GetProductApiV2ParameterBase } from "@insite/client-framework/Services/ProductServiceV2";
import {
    CarrierDto,
    CartModel,
    CollectAccountCollection,
    ProductModel,
    ShipViaDto,
} from "@insite/client-framework/Types/ApiModels";
import { CustomerPaymentProfile } from "@sonic/Services/GemecoApiModels";

const carrierCollectAccountsKey = "carrierCollectAccounts";

export function MapCollectAccounts(cart: CartModel) {
    if (cart!.properties[carrierCollectAccountsKey]) {
        const carrierCollectAccounts = JSON.parse(
            cart!.properties[carrierCollectAccountsKey],
        ) as CollectAccountCollection[];
        const carrierLookup: { [carrierId: string]: CarrierDto } = {};
        for (const carrier of cart.carriers ?? []) {
            if (carrier.id) {
                carrierLookup[carrier.id] = carrier;
            }
        }

        for (const collectAccount of carrierCollectAccounts) {
            if (collectAccount) {
                if (collectAccount.CarrierId) {
                    const carrier = carrierLookup[collectAccount.CarrierId];
                    carrier.collectAccounts = collectAccount.CollectAccounts;
                    if ((cart.carrier?.id ?? null) === collectAccount.CarrierId && cart.carrier) {
                        cart.carrier.collectAccounts = collectAccount.CollectAccounts;
                    }
                }
            }
        }

        delete cart.properties[carrierCollectAccountsKey];
    }
}

export function ParseReplacementProductData(product: ProductModel) {
    if (product.properties["replacementProductUrl"]) {
        product.replacementProductUrl = product.properties["replacementProductUrl"];
        product.replacementProductShortDescription = product.properties["replacementProductShortDescription"];
        delete product.properties["replacementProductUrl"];
        delete product.properties["replacementProductShortDescription"];
    }
}

export function AddPropertiesExpandParameter(parameter: GetProductApiV2ParameterBase) {
    if (!parameter.expand || !parameter.expand.includes("properties")) {
        parameter.expand = [...(parameter.expand ?? []), "properties"];
    }
}

const storedCreditCardOptionsKey = "storedCreditCardOptions";

export function MapCustomerPaymentProfiles(cart: CartModel) {
    if (cart!.properties[storedCreditCardOptionsKey]) {
        const customerPaymentProfiles = JSON.parse(
            cart!.properties[storedCreditCardOptionsKey],
        ) as CustomerPaymentProfile[];

        if (customerPaymentProfiles && customerPaymentProfiles.length > 0) {
            cart.customerPaymentProfiles = customerPaymentProfiles;
        }

        delete cart!.properties[storedCreditCardOptionsKey];
    }
}
